export { default as translations } from './translations.json';

/**
 * Get delivery proof from transaction.
 * @param {Object|null} transaction
 * @returns {Object|null}
 */
export const getDeliveryProof = (transaction) =>
  transaction?.attributes?.metadata?.deliveryProof || null;

export const hasDeliveryProof = (transaction) => !!getDeliveryProof(transaction);

/**
 * Get accepted MIME types for proof uploads.
 */
export const ACCEPTED_PROOF_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];

/**
 * Check if MIME type is accepted.
 * @param {string} mimeType
 * @returns {boolean}
 */
export const isAcceptedProofType = (mimeType) => ACCEPTED_PROOF_TYPES.includes(mimeType);
